import React from "react";

/* ---------- Table Wrapper ---------- */
const Table = React.forwardRef(({ style, maxHeight = "400px", ...props }, ref) => (
  <div
    style={{
      position: "relative",
      width: "100%",
      overflowX: "auto",
      height:maxHeight,             // Set max height for vertical scrolling
      overflowY: "auto",     // Enable vertical scrolling
    }}
  >
    <table
      ref={ref}
      style={{
        width: "100%",
        borderCollapse: "collapse",
        fontSize: "14px",
        color: "#0f172a",
        ...style
      }}
      {...props}
    />
  </div>
));
Table.displayName = "Table";

/* ---------- Header ---------- */
const TableHeader = React.forwardRef(({ style, ...props }, ref) => (
  <thead
    ref={ref}
    style={{
      borderBottom: "1px solid #e2e8f0",
      position: "sticky",
      top: 0,
      backgroundColor: "#ffffff",
      zIndex: 2,
      ...style
    }}
    {...props}
  />
));
TableHeader.displayName = "TableHeader";

/* ---------- Body ---------- */
const TableBody = React.forwardRef(({ style, ...props }, ref) => (
  <tbody
    ref={ref}
    style={{
      ...style
    }}
    {...props}
  />
));
TableBody.displayName = "TableBody";

/* ---------- Footer ---------- */
const TableFooter = React.forwardRef(({ style, ...props }, ref) => (
  <tfoot
    ref={ref}
    style={{
      borderTop: "1px solid #e2e8f0",
      backgroundColor: "#f8fafc",
      fontWeight: 500,
      ...style
    }}
    {...props}
  />
));
TableFooter.displayName = "TableFooter";

/* ---------- Row ---------- */
const TableRow = React.forwardRef(({ style, ...props }, ref) => (
  <tr
    ref={ref}
    style={{
      borderBottom: "1px solid #e2e8f0",
      transition: "background-color 0.2s ease",
      ...style
    }}
    onMouseEnter={(e) => {
      e.currentTarget.style.backgroundColor = "#f1f5f9";
    }}
    onMouseLeave={(e) => {
      e.currentTarget.style.backgroundColor = "transparent";
    }}
    {...props}
  />
));
TableRow.displayName = "TableRow";

/* ---------- Header Cell ---------- */
const TableHead = React.forwardRef(({ style, ...props }, ref) => (
  <th
    ref={ref}
    style={{
      height: "48px",
      padding: "0 16px",
      textAlign: "left",
      verticalAlign: "middle",
      fontWeight: 500,
      color: "#64748b",
      backgroundColor: "#ffffff",
      ...style
    }}
    {...props}
  />
));
TableHead.displayName = "TableHead";

/* ---------- Cell ---------- */
const TableCell = React.forwardRef(({ style, ...props }, ref) => (
  <td
    ref={ref}
    style={{
      padding: "16px",
      verticalAlign: "middle",
      color: "#0f172a",
      ...style
    }}
    {...props}
  />
));
TableCell.displayName = "TableCell";

/* ---------- Caption ---------- */
const TableCaption = React.forwardRef(({ style, ...props }, ref) => (
  <caption
    ref={ref}
    style={{
      marginTop: "16px",
      fontSize: "14px",
      color: "#64748b",
      textAlign: "left",
      ...style
    }}
    {...props}
  />
));
TableCaption.displayName = "TableCaption";

export {
  Table,
  TableHeader,
  TableBody,
  TableFooter,
  TableHead,
  TableRow,
  TableCell,
  TableCaption
};
